import * as React from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { AuditLogDrawerContent } from "@/components/audit-log-drawer";
import { EntityDrawer } from "@/components/entity-drawer";
import type { AuditLogsOutletContext } from "./audit-logs-layout";

export function AuditLogDetail() {
	const { logId } = useParams<{ logId: string }>();
	const outletContext = useOutletContext<AuditLogsOutletContext | undefined>();
	const logs = outletContext?.logs ?? [];
	const isLoading = outletContext?.isLoading ?? false;
	const data = React.useMemo(() => {
		if (!logId) {
			return null;
		}
		const numericLogId = Number.parseInt(logId, 10);
		if (Number.isNaN(numericLogId)) {
			return null;
		}
		return logs.find((log) => log.id === numericLogId) ?? null;
	}, [logId, logs]);

	return (
		<EntityDrawer
			title="Audit Log Details"
			isLoading={isLoading}
			isNotFound={!isLoading && !data}
			notFoundMessage="Audit log not found"
			parentPath="/audit-logs"
		>
			{data && <AuditLogDrawerContent log={data} />}
		</EntityDrawer>
	);
}
